import React, { Component, Fragment } from 'react'
import { Button } from '@drifthq/tide-core'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'
 
import GoogleLogin from 'react-google-login'
import config from 'config'

const GOOGLE_LOGIN_CLOSED_ERROR = "popup_closed_by_user"
const GOOGLE_LOGIN_ACCESS_DENIED_ERROR = "access_denied"

class GoogleAuth extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.search && this.props.pathname.includes("google")) {
      this.onLoading()
      this.onHideError()
      const token = queryString.parse(this.props.search).code
      this.props.onProcessingExternalGoogleCode(token)
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.oauthError !== this.props.oauthError) && (this.props.oauthError !== false)) {
      this.setState({ loading: false })
    }
  }

  onHideError = () => {
    this.props.actions.setOAuthError(false)
  }

  onLoading = () => {
    this.setState({ loading: true })
  }

  handlePopUpError = (response) => {
    if (response.error === GOOGLE_LOGIN_ACCESS_DENIED_ERROR) {
      this.props.actions.setOAuthError("Sorry, we ran into an error! Try again")
    } else if (response.error === GOOGLE_LOGIN_CLOSED_ERROR) {
      this.setState({ loading: false })
    }
  }

  render() {
    const { onProcessingGoogleCode } = this.props
    const { loading } = this.state

    return (
      <Fragment>
        { loading ?
          <Button className='touchless-start-button-loading' type="tertiary" loading={true} size="large"/>
          : <GoogleLogin
            clientId={config.GOOGLE_CLIENT_ID}
            responseType='code'
            accessType='offline'
            scope='https://www.googleapis.com/auth/calendar'
            buttonText='Sign up with Google'
            onSuccess={onProcessingGoogleCode}
            onFailure={this.handlePopUpError}
            onRequest={() => {this.onHideError(); this.onLoading();}}
            theme='dark'
            className='touchless-start-google-button'
          />
        }
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  pathname: RoutingSelectors.getPathname(state),
  search: RoutingSelectors.getSearch(state),
  oauthError: OrgSelectors.getOAuthError(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setOAuthError: OrgActions.setOAuthError
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(GoogleAuth)


// WEBPACK FOOTER //
// ./src/layouts/SignupChoiceCard/GoogleAuth.js